<template>
  <div :class="{'user-info-layout' : isNewVersion}">
    <Dropdown
      placement="bottom-end"
      :style="{marginRight: '20px', fontSize: '16px'}"
      @on-click="menuHandler"
    >
      <div class="header-icon-layout" v-if="isNewVersion">
        <!-- <Avatar icon="person" size="small"/>&nbsp;&nbsp; -->
        <img class="user-img" src="../../../../../assets/home/avatar.jpg">
        <span>{{user.loginName && user.loginName.toUpperCase()}}</span>&nbsp;&nbsp;
        <md-icon class="md-icon-arrow-down" name="arrow-down"></md-icon>
        <!-- <Icon type="chevron-down"></Icon> -->
      </div>
      <a v-else>
        <Avatar icon="person" size="small"/>&nbsp;&nbsp;
        <span>{{user.loginName}}</span>&nbsp;&nbsp;
        <!-- <Icon type="chevron-down"></Icon> -->
      </a>
      <DropdownMenu slot="list">
        <DropdownItem divided name="logout">{{$t('header.logout')}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Dropdown
      placement="bottom-end"
      :style="{marginRight: isNewVersion ? 0 : '20px', fontSize: '14px'}"
      @on-click="menuHandler"
    >
      <span class="language">
        {{isNewMenu ? languageShow(this.$i18n.locale) : (twLanguage || user.fdLangType)}}
      </span>
      <DropdownMenu slot="list">
        <template v-if="isNewMenu">
            <DropdownItem v-for="item in languageTypeList" :key="item.languageType" :name="item.languageType">{{ item.languageDesc }}</DropdownItem>
        </template>
        <template v-else>
            <DropdownItem name="zh-CN">中文</DropdownItem>
            <DropdownItem name="en-US">English</DropdownItem>
            <!-- <DropdownItem name="ja-JP">日本語の</DropdownItem> -->
            <DropdownItem name="th">ภาษาไทย</DropdownItem>
        </template>
        <!-- <DropdownItem name="zh-CN">中文</DropdownItem>
        <DropdownItem name="en-US">English</DropdownItem>
        <DropdownItem name="ja-JP">日本語の</DropdownItem>
        <DropdownItem name="th">ภาษาไทย</DropdownItem>
        <DropdownItem name="vi">Tiếng Việt/㗂越</DropdownItem>
        <DropdownItem name="pt">Português</DropdownItem>
        <DropdownItem name="ida">Bahasa Indonesia</DropdownItem> -->
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { logout, logoutAccount } from '@/utils/index';
import { switchLang, changeLanKey } from '@/common/js/user';
import store from '@/store/index';
import cookie from 'js-cookie';

export default {
  name: 'User',
  computed: {
    ...mapGetters(['menus', 'user', 'isNewMenu', 'isNewVersion']),
    // 语言列表,使用国际化平台数据languageTypeList
    languageTypeList() {
      const langMap = {
        'zh': 'zh-CN',
        'en': 'en-US',
      };
      const defaultList = [
            {
                "languageType": "zh",
                "languageDesc": "中文",
            },
            {
                "languageType": "en",
                "languageDesc": "英文-English",
            },
            {
                "languageType": "th",
                "languageDesc": "泰语-ภาษาไทย",
            }
      ];
	  /* 屏蔽 “日语”、“俄语”、“葡萄牙语” */
      const res = (JSON.parse(localStorage.getItem('languageTypeList')) || defaultList).filter((item) => !['ja', 'ru', 'pt'].includes(item.languageType)).map(item => {
        item.languageType = langMap[item.languageType] || item.languageType; // 由于历史代码原因，zh转成zh-CN；en转成en-US
        return item
      });
      return res
    },
  },
  data() {
    return {
        twLanguage: ''
    };
  },
  methods: {
    setCookie (name, value, params) {
      document.cookie = name + '=' + value + ';domain=' + params.domain || window.location.hostname;
    },
    menuHandler(name) {
        if (this.isNewMenu) {
            if (!name) return;
            switch (name) {
                case 'logout':
                    debugger;
                logoutAccount();
                logout(this.$router);
                break;
                default:
                    localStorage.setItem('autoSwitch', true);
                    this.switchLangFn(name);
                    break;
            }
        } else {
            if (!name) return;
            localStorage.removeItem('int-language');
            switch (name) {
                case 'logout':
                logout(this.$router);
                break;
                case 'zh-CN':
                case 'en-US':
                // case 'ja-JP':
                case 'th':
                    if (name === 'th') {
                        localStorage.setItem('int-language', name);
                    }
                    this.switchLangFn(name);
                break;
                default:
                break;
            }
        }
    },
    switchLangFn(name) {
        if (!name) return;
        switchLang(name, this.isNewMenu).then(success => {
            if (success) {
                store.dispatch('UPDATE_LANG');
                cookie.set('oam_locale', changeLanKey(name), {domain: '.midea.com'});
				window.location.reload();
            } else {
              this.$Message.error('语言切换失败');
            }
          }, () => {
            this.$Message.error('语言切换失败');
          });
    },
    /* 自动切换语言 */
    autoSwitch() {
        const { locale } = this.$i18n;
        const lang = {
            'zn': 'zh-CN',
            'en': 'en-US',
            'ja-JP': 'ja',
            'th': 'th',
            'vi': 'vi',
            'pt': 'pt',
            'ida': 'ida',
            'ar': 'ar',
        };
        if (navigator.language.indexOf(locale.split('-')[0]) === -1) {
            if (!localStorage.getItem('autoSwitch')) {
                localStorage.setItem('autoSwitch', true);
                this.switchLangFn(lang[navigator.language.split('-')[0]]);
            }
        }
    },
    languageShow(lang) {
        /* 把日语当成阿拉伯语 */
        if (lang === 'ja-JP') {
            lang = 'ar';
        }
        const desc = this.languageTypeList.find((item) => lang === item.languageType)?.languageDesc;
        return desc.includes('-') ? desc.split('-')[1] : desc;
    },
  },
  mounted() {
    if (!this.isNewMenu) {
        this.twLanguage = localStorage.getItem('int-language');
    }
    this.autoSwitch();
  },
};
</script>

<style lang="less" scoped>
.language {
  display: inline-block;
  padding: 0px 10px 0 25px;
  background: url('data:image/png;base64,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') no-repeat 0 center;
  background-size: 25%;
  cursor: pointer;
}
.user-info-layout {
    display: flex;
    align-items: center;
    .language {
        color: #454f5b;
        padding-right: 0;
    }
}
.header-icon-layout {
    display: flex;
    align-items: center;
    color: #454f5b;
    font-size: 14px;
}
.user-img {
    height: 20px;
    border-radius: 50%;
    margin-right: 5px;
}
</style>
